$(document).ready(function(){ 
  if($(".slider").length>0){
    $(".slider").slick({
      draggable: true,
      autoplay: true,
      autoplaySpeed: 7000,
      arrows: true,
      dots: true,
      fade: true,
      speed: 500,
      infinite: true,
      cssEase: 'ease-in-out',
      touchThreshold: 100
    });
  }

  
  //sub menu active
  $('span.header__active-menu-item').parent('a').addClass('w--current');
  $('span.header__active-menu-item').removeClass('header__active-menu-item');
  $('.header__inline-menu a.w--current').parent('summary').parent('details').attr("open","open");

  //main category breadcrumb
  var main_cat_lbl = $('.header__inline-menu a.w--current span').text();
  var main_cat_src = $('.header__inline-menu a.w--current').attr('href');
  $('<li class="breadcrumbs__item"><a class="breadcrumbs__link" href="'+main_cat_src+'">'+main_cat_lbl+'</a></li>').insertBefore('.cat_breadcrumbs__item');
  if($('.cat_breadcrumbs__item2 a.w--current').attr('href')==main_cat_src){ 
  }else{  
    $('<li class="breadcrumbs__item"><a class="breadcrumbs__link" href="'+main_cat_src+'">'+main_cat_lbl+'</a></li>').insertBefore('.cat_breadcrumbs__item2');
  }

  
  //ticking machine
  var percentTime;
  var tick;
  var time = 1;
  var progressBarIndex = 0;
  var progress = $('.inProgress');

  $('.progressBarContainer .progressBar').each(function (index) {
    var progress = "<div class='inProgress inProgress" + index + "'></div>";
    $(this).html(progress);
  });

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    tick = setInterval(interval, 30);
  }

  function interval() {
    if($(".slider").length>0){
      if (($('.slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
        progressBarIndex = $('.slider .slick-track div[aria-hidden="false"]').data("slickIndex");
  
        console.log(progressBarIndex);
  
        if (progressBarIndex == 1) {
          $(".inProgress0").addClass('on');
          $(".inProgress1").removeClass('on');
        }
        else if (progressBarIndex == 0) {
          $(".inProgress0").addClass('on');
          $(".inProgress1").addClass('on');
        }
        else if (progressBarIndex == 0) {
          $(".inProgress0").removeClass('on');
          $(".inProgress1").removeClass('on');
        }
        startProgressbar();
  
      } else {
        percentTime += 1 / (time + 2);
        $('.inProgress' + progressBarIndex).css({
          width: percentTime + "%"
        });
        if (percentTime >= 100) {
          $('.single-item').slick('slickNext');
  
          //console.log(progressBarIndex);
  
          if (progressBarIndex == 0) {
            $(".inProgress0").addClass('on');
  
          }
          else if (progressBarIndex == 1) {
            $(".inProgress0").addClass('on');
            $(".inProgress1").addClass('on');
          }
          else if (progressBarIndex == 0) {
            $(".inProgress0").removeClass('on');
            $(".inProgress1").removeClass('on');
          }
  
          progressBarIndex++;
  
          if (progressBarIndex > 0) {
            progressBarIndex = 0;
          }
          startProgressbar();
  
        }
  
      }
    }
  }

  function resetProgressbar() {
    $('.inProgress').css({
      width: 0 + '%'
    });
    clearInterval(tick);
  }
  startProgressbar();
  // End ticking machine

  $('.progressBarContainer div').click(function () {
    clearInterval(tick);
    var goToThisIndex = $(this).find("span").data("slickIndex");
    $('.single-item').slick('slickGoTo', goToThisIndex, false);
    startProgressbar();
  });
});



/**  product page ****/
function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Read more"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less"; 
    moreText.style.display = "inline";
  }
}
/** end product page ****/
/** account page tab****/
function displayContent(event, contentNameID) {
  let content =
      document.getElementsByClassName("AccountTabcontent");
  let totalCount = content.length;

  // Loop through the content class
  // and hide the tabs first
  for (let count = 0;
       count < totalCount; count++) {
    content[count].style.display = "none";
  }

  let links =
      document.getElementsByClassName("linkClass");
  totalLinks = links.length;

  // Loop through the links and
  // remove the active class
  for (let count = 0;
       count < totalLinks; count++) {
    links[count].classList.remove("active");
  }

  // Display the current tab
  document.getElementById(contentNameID)
  .style.display = "block";

  // Add the active class to the current tab
  event.currentTarget.classList.add("active");
}
/** account page tab end****/

$(document).ready(function(){ 

  /**custom filter***/
  var pageurl = window.location.href;
  //console.log(pageurl);  

  $(".header__inline-menu ul li.FirstLevelNav").each(function(){
    var navlink = $(this).attr("data-url");
    //console.log("navlink "+navlink);  
    if (pageurl.indexOf(navlink) > -1) {
      $(this).find(".FirstLevelSummary").trigger( "click" );
      $(this).find(".FirstLevelDetails").attr("open");
      $(this).find(".FirstLevelSummary").attr("aria-expanded","true");
      //console.log("if");
    }else{
      //console.log("else");
      $(".FirstlevelchildDetails").addClass("test");
      $(".FirstlevelchildDetails").attr("open","open");
      $(".FirstlevelchildSummary").attr("aria-expanded","true");
    }
  });

  $(".CollectionFilter-innerUL li").each(function(){
    var filterurlTag = $(this).children("a").attr("href");
    if (window.location.href.indexOf(filterurlTag) > -1) {
      $(this).addClass('filter-added');
    }
    if ($(this).hasClass("filter-added")) {
      $(this).children("a").children(".FilterActive").css('display','block');
      $(this).children("a").children(".FilterunActive").css('display','none');
    }
  });

  $(".selectTypeSec select.SelectBox").on('change', function() {
    var selectOption = $(this).val();
    //console.log("selectOption "+selectOption);
    $(".CollectionFilter-innerUL li.option").each(function(){
      var liOption = $(this).children("a").attr("href");
      //console.log("liOption "+liOption);

      if (selectOption.indexOf(liOption) > -1) {
        //console.log("if liOption "+liOption);
        $(this).children("a").trigger( "click" );
      }
    });
  });
  
  $(".CollectionFilter-innerUL li a").click(function (e) {
    e.preventDefault();
    
    if (pageurl.indexOf("?page=2") > -1) {
      var spliturl = pageurl.split("?");
      var collectionurl = spliturl[0];
      var newcollectionurl = collectionurl;
      console.log("if "+newcollectionurl);
    }else{
      var newcollectionurl = pageurl;
      console.log("else "+newcollectionurl);
    }
    
    var updatedValue=" ";  
    var parentValue =$(this).parent("li");
    if (parentValue.hasClass("filter-added")){
      parentValue.removeClass('filter-added');
      $(this).children(".FilterActive").css('display','none');
      $(this).children(".FilterunActive").css('display','block');
      var newurl= newcollectionurl;
    } 
    else {
      parentValue.addClass('filter-added');
      $(".filter-added").each(function(i){
        var filterValue = $(this).children("a").attr("href");
        //console.log("filterValue " + filterValue);
        if(i==0){
          var NewFilterValue = filterValue;
        }
        else{
          var NewFilterValue = filterValue + "+" + updatedValue ;
        }
        //console.log("NewFilterValue "+ NewFilterValue);
        updatedValue = NewFilterValue;
        //console.log("updatedValue "+ updatedValue);
      });
      var newurl= newcollectionurl +"/" + updatedValue;
      //console.log("else newurl "+ newurl);
      $(this).children(".FilterActive").css('display','block');
      $(this).children(".FilterunActive").css('display','none');
    }
    $.ajax({
      type: 'GET',
      url: newurl,
      dataType: 'html',
      success: function(data){
        //console.log("data "+ data);
        var FitlterProducts = $(data).find(".ProductListSec").html();  
        //console.log("FitlterProducts"+FitlterProducts);
        $(".ProductListSec").html(FitlterProducts);
        history.pushState({
          page: newurl
        }, newurl, newurl);
      }
    });
  });
  /**custom filter end***/

  /** account page tab****/
  $(".ViewOrder").click(function(e){
    e.preventDefault();
    console.log("click");
    $(".OrderListSec").hide();
    var singleorder = $(this).attr("href");
    $.ajax({
      url: singleorder,
      type: 'GET',
      dataType: 'html',
      success: function(data) { 
        //console.log(data);
        var OrderData = $(data).find(".CustomerOrderSec").html();
        $(".SingleOrderDetail").show();
        $(".SingleOrderDetail").html(OrderData);
      }
    });
  });
  
  $('body').on('click', '.BackToOrderListSec', function() {
    //console.log("click");
    $(".OrderListSec").show();
    $(".SingleOrderDetail").hide();
  });

  //var customerAddressUrl = $('.AddressBookPg').attr('data-addressurl');
  if (pageurl.indexOf("account/addresses") > -1) {
    $(".AccountTabUlSec li").each(function(){
      if ($(this).hasClass('AddressBookPg')){
        $(this).children('button.linkClass').addClass('active');
        $(this).parent('.AccountTabUlSec').siblings('#address-book').css("display","block");
      } else {
        $(this).children('button.linkClass').removeClass('active');
      }
    });
  }else{
    //window.location.href = customerAddressUrl;
  }
  
  $(".AddressBookPg").click(function(){
    var addressPgUrl = $(this).attr("data-AddressUrl");
    if (window.location.href.indexOf(addressPgUrl) > -1) {
    }else{
      window.location.href = addressPgUrl;
    }
  });
  /** account page tab end****/  
    
  /** FAQ page ****/  
  $('.accordion a').click(function(){
    $(this).toggleClass('active');
    $(this).next('.content').slideToggle(400);
  });
  /** FAQ page end****/  

  /* Variant color click */
  $('.v_image').click(function(){
    var v_id = $(this).attr('v_image');
    var v_href = window.location.href.split("?");
    window.location.href = v_href[0]+'?variant='+v_id;
    
    /*$('.product__media-list li').removeClass('is-active');
    $('.product__media-list li').hide();
    $('.product__media-list li').each(function( index ) {
      console.log(v_id+'='+index);
      if(v_id==index){
        $(this).addClass('is-active');
        $(this).show();
      }
    });*/    
  });  

  $('.v_img_list').hover(function() {
    var p_id = $(this).attr('data-product-id');
    var v_img = $(this).attr('data-variant-image');
    var real_img = v_img.replace(/_small./gi, "."); 
    var v_link = $(this).attr('href');

    var real_img_set1 = real_img + '&width=165 165w,';
    var real_img_set2 = real_img + '&width=360 360w,';
    var real_img_set3 = real_img + '&width=533 533w,';
    var real_img_set4 = real_img + '&width=720 720w,';
    var real_img_set5 = real_img + '&width=940 940w,';
    var real_img_set6 = real_img + ' 1024w';
    var real_img_set = real_img_set1 + real_img_set2 + real_img_set3 + real_img_set4 + real_img_set5 + real_img_set6;
    
    $('#v_img_list_'+p_id).attr('src',real_img);
    $('#v_img_list_'+p_id).attr('srcset',real_img_set);
    
    $('#v_img_list_'+p_id).parent().attr('href',v_link);
  });    

  $('#product-grid .grid__item .CollectionProductImage').each(function( index ) {
    var cat_a = $(this).attr('href');
    var cat_a2 = cat_a.split('/products/');

    $('#product-grid .grid__item .product_ColorVariant .colourselectoption .v_img_list').each(function( index ) {
      var prod_a = $(this).attr('href');
      var prod_a2 = prod_a.split("?");
      if(prod_a.indexOf("/collections/")==-1 && ("/products/"+cat_a2[1])==prod_a2[0]){
        $(this).attr('href',cat_a2[0]+prod_a);
      }
    });
  });

  $('.QuantityAddtoCartSec .quantity__button').click(function(){
    var nm = $(this).attr('name');
    var qt = $('.QuantityAddtoCartSec .quantity__input').val();
    if(nm=='minus'){
      qt = parseInt(qt) - 1;
    }else if(nm=='plus'){
      qt = parseInt(qt) + 1;
    }
    if(qt<=0){
      qt = 1;
    }
    $('.QuantityAddtoCartSec .quantity__input').val(qt);
  });

  $('.cart-item__quantity .quantity__button').click(function(){
    var nm = $(this).attr('name');
    var lb = $(this).parent().parent().parent().parent().attr('id');
    lb = lb.split('-');
    lb = lb[1];
    var qt = $('#Quantity-'+lb).val();
    if(nm=='minus'){
      qt = parseInt(qt) - 1;
    }else if(nm=='plus'){
      qt = parseInt(qt) + 1;
    }
    if(qt<=0){
      qt = 1;
    }
    $('#Quantity-'+lb).val(qt);
  });
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product_ColorVariant').forEach(productVariant => {
        let firstColorLabel = productVariant.querySelector('.colourselectoption .color-name-label');
        
        if (firstColorLabel) {
            let colorName = firstColorLabel.textContent;
            let colorNameDisplay = productVariant.querySelector('.color-name-display');
            colorNameDisplay.textContent = colorName;
        }

        productVariant.querySelectorAll('.colourselectoption').forEach(item => {
            item.addEventListener('mouseenter', function() {
                var colorValue = this.querySelector('.color-name-label').textContent;
                var colorNameDisplay = productVariant.querySelector('.color-name-display');
                colorNameDisplay.textContent = colorValue;
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product_ColorVariant').forEach(variant => {
        const swatches = variant.querySelectorAll('.colourselectoption');

        const defaultSwatch = variant.querySelector('.default-swatch');
        if (defaultSwatch) {
            defaultSwatch.classList.add('line-above-swatch');
        }

        swatches.forEach(swatch => {
            swatch.addEventListener('mouseenter', function() {
                swatches.forEach(el => el.classList.remove('line-above-swatch', 'default-swatch'));

                this.classList.add('line-above-swatch');
            });
        });
    });
});

/////Filterlogic for colors on collection pages
document.addEventListener("DOMContentLoaded", function() {
    var filterButtons = document.querySelectorAll('.filtercolorbutton');
    var selectedColors = []; // Array to store selected colors

    filterButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            var filterColor = this.getAttribute('data-filter-color');

            // Toggle active class on the clicked button
            this.classList.toggle('active');

            // Update selectedColors array based on button state
            if (this.classList.contains('active')) {
                selectedColors.push(filterColor);
            } else {
                selectedColors = selectedColors.filter(function(color) {
                    return color !== filterColor;
                });
            }

            // Filter products based on selected colors
            filterProductsByColors(selectedColors);
        });
    });
});

function filterProductsByColors(colors) {
    // Logic to show/hide products based on selected colors
    document.querySelectorAll('.grid__item.product-card').forEach(function(product) {
        var productColorsAttribute = product.getAttribute('data-colors');
        var productColors = productColorsAttribute ? productColorsAttribute.split(',') : [];

        try {
            if (colors.length === 0 || colors.some(color => productColors.includes(color))) {
                product.style.display = 'block';
            } else {
                product.style.display = 'none';
            }
        } catch (error) {
            console.error("Error filtering products:", error);
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    // Get the elements to be clicked
    var triggerElement2 = document.getElementById('Details-HeaderMenu-2');
    var triggerElement3 = document.getElementById('Details-HeaderMenu-3');

    // Get the element to be hidden
    var targetElement = document.getElementById('HeaderMenu-MenuList-1');
    let menuItems = document.querySelectorAll('#HeaderMenu-MenuList-2 li');

    // Function to toggle the target element's display
    function toggleDisplay() {
        if (targetElement.style.display !== 'none') {
            targetElement.style.display = 'none';
        } else {
            targetElement.style.display = '';
        }
    }

    // Add click event listeners to the trigger elements
    triggerElement2.addEventListener('click', toggleDisplay);
    triggerElement3.addEventListener('click', toggleDisplay);

    // Add click event listeners to menu items
    menuItems.forEach(item => {
        item.addEventListener('click', toggleDisplay);
    });
});

document.addEventListener('DOMContentLoaded', function() {
    var targetElementSelector1 = '#Details-HeaderMenu-1';
    var isOpenSelector2 = '#Details-HeaderMenu-2[open="open"]';
    var isOpenSelector3 = '#Details-HeaderMenu-3[open="open"]';
    var menuItemsSelector = '#HeaderMenu-MenuList-2 li';

    function removeOpenAttribute(selector) {
        var targetElement = document.querySelector(targetElementSelector1);
        var isOpen = document.querySelector(selector);
        if (isOpen && targetElement && targetElement.hasAttribute('open')) {
            targetElement.removeAttribute('open');
        }
    }

    function checkAndToggle() {
        removeOpenAttribute(isOpenSelector2);
        removeOpenAttribute(isOpenSelector3);
    }

    checkAndToggle();

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
                checkAndToggle();
            }
        });
    });

    var config = { childList: true, subtree: true };

    observer.observe(document.body, config);

    var menuItems = document.querySelectorAll(menuItemsSelector);
    menuItems.forEach(function(item) {
        item.addEventListener('click', checkAndToggle);
    });

    //setInterval(checkAndToggle, 1000); // Adjust the interval as needed
});












